/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useState } from 'react'
import { MdCheck } from 'react-icons/md'
import { Grid } from '@material-ui/core'
import * as Yup from 'yup'

import IBancoResponse from 'modules/pagamentos/domain/entities/IBancoResponse'
import IFindFavorecidosContaBancariaResponse from 'modules/pagamentos/domain/entities/IFindFavorecidosContaBancariaResponse'
import { IFindBancos } from 'modules/pagamentos/domain/usecases/FindBancos'
import { useTransferencia } from 'modules/pagamentos/hooks/useTransferencia'
import Button from 'shared/components/Button'
import Form from 'shared/components/Form'
import { IFormControl } from 'shared/components/Form/FormComponent.types'
import Input from 'shared/components/Input'
import { Label } from 'shared/components/Input/styles'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Modal from 'shared/components/Modal'
import Radio from 'shared/components/Radio'
import Scaffold from 'shared/components/Scaffold'
import SnackBar from 'shared/components/SnackBar'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import dimensions from 'shared/styles/dimensions'
import iconConcluido from 'shared/assets/icons/icon-concluido-blue.png'
import Autocomplete from 'shared/components/Autocomplete'

import { ContainerModal, Icon, TextModal, TitleArea } from './styles'

export type TProps = {
  findAll: IFindBancos
}

const NovaConta: React.FC<TProps> = ({ findAll }) => {
  const { frotistaId, frotista } = useFrotista()
  const { setShowNovaConta, setContaFavorecido, setSalvarContaFavorecido } =
    useTransferencia()
  const [nomeFavorecido, setNomeFavorecido] = useState('')
  const [cnpjFavorecido, setCnpjFavorecido] = useState('')
  const [bancos, setBancos] = useState([])

  const [banco, setBanco] = useState({} as IBancoResponse)
  const [nomeContaInput, setNomeContaInput] = useState('')
  const [agenciaInput, setAgenciaInput] = useState('')
  const [numeroContaInput, setNumeroContaInput] = useState('')
  const [digitoInput, setDigitoInput] = useState('')
  const [bancoInput, setBancoInput] = useState('')
  const [tipoContaRadio, setTipoContaRadio] = useState(0)

  const [loading, setLoading] = useState(false)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [openModalSucesso, setOpenModalSucesso] = useState(false)
  const [message, setMessage] = useState('')

  const opcoesTipoConta = {
    corrente: 1,
    poupanca: 2,
  }

  const handleSubmit = async () => {
    let errorMessage = ''
    if (nomeContaInput.trim() === '') errorMessage += '- Nome da Conta\n'
    if (agenciaInput.trim() === '') errorMessage += '- Agencia\n'
    if (numeroContaInput.trim() === '') errorMessage += '- Numero da conta\n'
    if (digitoInput.trim() === '') errorMessage += '- Dígito\n'
    if (tipoContaRadio === 0) errorMessage += '- Tipo de Conta\n'
    if (bancoInput.trim() === '') errorMessage += '- Banco\n'
    if (errorMessage.trim() !== '') {
      let message = 'Erro! Os campos abaixo são obrigatórios:\n'
      message += errorMessage
      setOpenSnackBar(true)
      setMessage(message)
    } else {
      setOpenModalSucesso(true)
    }
  }

  const handleBanco = (newValue: string) => {
    setBancoInput(newValue)
  }

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true)
        const response = await findAll.execute()
        setBancos(response)

        if (frotistaId) {
          setNomeFavorecido(frotista.razao_social)
          setCnpjFavorecido(frotista.cnpj)
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        setOpenSnackBar(true)
        setMessage(
          'Problemas ao consultar os bancos, tente novamente mais tarde',
        )
      }
    }
    init()
  }, [frotista, findAll, frotistaId])

  const dadosFavorecido = () => {
    return (
      <Grid container style={{ paddingBottom: 30 }}>
        <Grid item md={6}>
          <Label style={{ marginBottom: dimensions.spaces.small }}>
            Nome do favorecido
          </Label>
          <Text color={colors.grayDark} weight="700">
            {nomeFavorecido}
          </Text>
        </Grid>
        <Grid item md={6}>
          <Label style={{ marginBottom: dimensions.spaces.small }}>
            Documento do favorecido
          </Label>
          <Text color={colors.grayDark} weight="700">
            {cnpjFavorecido}
          </Text>
        </Grid>
      </Grid>
    )
  }

  const dadosNomeBanco = (formControl: IFormControl) => {
    return (
      <Grid container spacing={3}>
        <Grid item md={6}>
          <Input
            placeholder="Digite aqui"
            name="nomeConta"
            type="text"
            formControl={formControl}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setNomeContaInput(event.target.value)
            }}
            label="Nome da conta"
          />
        </Grid>

        <Grid item md={6}>
          <Autocomplete
            label="Bancos"
            placeholder="Digite para buscar o banco"
            options={bancos}
            inputValue={bancoInput}
            onInputChange={(event, newInputValue) => {
              handleBanco(newInputValue)
            }}
            onChange={(
              event: ChangeEvent<HTMLInputElement>,
              newValue: IBancoResponse,
            ) => {
              setBanco(newValue)
            }}
            getOptionLabel={option =>
              `${(option as IBancoResponse).id} - ${
                (option as IBancoResponse).nome
              }`
            }
            loading={loading}
          />
        </Grid>
      </Grid>
    )
  }

  const tipoConta = () => {
    return (
      <Grid container style={{ margin: `${dimensions.spaces.large}px 0` }}>
        <Grid item md={6}>
          <Label style={{ marginBottom: dimensions.spaces.small }}>
            Tipo de conta
          </Label>
          <Grid container>
            <Radio
              id="corrente"
              label="Corrente"
              name="type"
              value="CORRENTE"
              checked={tipoContaRadio === 1}
              onChange={(value: string) =>
                setTipoContaRadio(opcoesTipoConta.corrente)
              }
            />
            <span style={{ width: 100 }}></span>
            <Radio
              id="poupanca"
              label="Poupança"
              name="type"
              value="POUPANCA"
              checked={tipoContaRadio === 2}
              onChange={(value: string) =>
                setTipoContaRadio(opcoesTipoConta.poupanca)
              }
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }

  const dadosAgenciaContaDigito = (formControl: IFormControl) => {
    return (
      <Grid container spacing={3}>
        <Grid item md={4}>
          <Input
            placeholder="Digite a agência"
            name="agencia"
            type="number"
            formControl={formControl}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setAgenciaInput(event.target.value)
            }}
            label={'Agência'}
          />
        </Grid>

        <Grid item md={4}>
          <Input
            placeholder="Digite o número da conta"
            name="numeroConta"
            type="number"
            formControl={formControl}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setNumeroContaInput(event.target.value)
            }}
            label={'Conta'}
          />
        </Grid>

        <Grid item md={4}>
          <Input
            placeholder="Digite o dígito da conta"
            name="digito"
            type="number"
            formControl={formControl}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setDigitoInput(event.target.value)
            }}
            label={'Dígito'}
          />
        </Grid>
      </Grid>
    )
  }

  const handleClickContinuar = () => {
    const novaConta: IFindFavorecidosContaBancariaResponse = {
      nome_conta: nomeContaInput,
      agencia: +agenciaInput,
      codigo_bacen_banco: banco.id,
      conta: +numeroContaInput,
      digito_conta: +digitoInput,
      nome_banco: bancoInput,
      tipo_conta: tipoContaRadio,
    }
    setContaFavorecido(novaConta)
    setSalvarContaFavorecido(true)
    setShowNovaConta(false)
  }

  const handleClickVoltar = () => {
    setShowNovaConta(false)
  }

  return (
    <Scaffold
      isNextButtonDisabled={openSnackBar}
      titleBackButton="Voltar"
      titleNextButton="Salvar"
      onClickNextButton={handleSubmit}
      onClickBackButton={handleClickVoltar}
    >
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}

      <Form
        enableReinitialize
        onSubmit={() => handleSubmit()}
        initialValues={{
          nomeConta: nomeContaInput,
          agencia: agenciaInput,
          numeroConta: numeroContaInput,
          digito: digitoInput,
        }}
        validationSchema={() => ({
          nomeConta: Yup.string(),
          agencia: Yup.number(),
          numeroConta: Yup.number(),
          digito: Yup.number(),
        })}
      >
        {formControl => (
          <>
            <Grid container>
              <Grid item xs={12}>
                <TitleArea>Adicionar conta</TitleArea>
              </Grid>

              {dadosFavorecido()}

              {dadosNomeBanco(formControl)}
              {tipoConta()}

              {dadosAgenciaContaDigito(formControl)}

              {openSnackBar ? (
                <SnackBar
                  open={openSnackBar}
                  message={message}
                  setOpen={setOpenSnackBar}
                  severity={'error'}
                />
              ) : (
                <></>
              )}

              {openModalSucesso && (
                <Modal
                  size="small"
                  openModal={openModalSucesso}
                  showCloseButton={false}
                >
                  <ContainerModal>
                    <Icon src={iconConcluido} />
                    <div>
                      <TextModal>
                        Conta pré-cadastrada! Para finalizar o cadastro realize
                        uma transferência para ela
                      </TextModal>
                    </div>

                    <Button
                      color={colors.orange}
                      onClick={handleClickContinuar}
                    >
                      <MdCheck />
                      Continuar
                    </Button>
                  </ContainerModal>
                </Modal>
              )}
            </Grid>
          </>
        )}
      </Form>
    </Scaffold>
  )
}

export default NovaConta
